import './App.css';
import Header from './component/Header/header';
import Navbar from './component/Navbar/navbar';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Header/>
    </div>
  );
}

export default App;